import { registerPlugin } from '@capacitor/core';

import type { GarminSDKPlugin } from './definitions';

const GarminSDK = registerPlugin<GarminSDKPlugin>('GarminSDK', {
  web: () => import('./web').then((m) => new m.GarminSDKWeb()),
});

export * from './definitions';
export { GarminSDK };
